import { storeActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

export function taskCases(builder: ActionReducerMapBuilder<NotificationState>) {
  builder
    .addCase(
      storeActions.task.delete.fulfilled,
      (
        state,
        {
          meta: {
            arg: { task },
          },
          payload: { notify },
        },
      ) => {
        if (!notify) return
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xDeleted',
          descriptionTransOptions: { value: task.title || task.content },
          icon: 'check',
          id: generateId(),
          undo: {
            actionType: 'delete',
            isUndone: false,
            object: task,
            type: 'task',
          },
        })
      },
    )
    .addCase(
      storeActions.task.archive.fulfilled,
      (
        state,
        {
          meta: {
            arg: { task },
          },
          payload: { notify },
        },
      ) => {
        if (!notify) return
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xArchived',
          descriptionTransOptions: { value: task.title || task.content },
          icon: 'check',
          id: generateId(),
          undo: {
            actionType: 'archive',
            isUndone: false,
            object: task,
            type: 'task',
          },
        })
      },
    )
    .addCase(
      storeActions.task.unarchive.fulfilled,
      (
        state,
        {
          meta: {
            arg: { task },
          },
          payload: { notify },
        },
      ) => {
        if (!notify) return
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUnarchived',
          descriptionTransOptions: { value: task.title || task.content },
          icon: 'check',
          id: generateId(),
          undo: {
            actionType: 'unarchive',
            isUndone: false,
            object: task,
            type: 'task',
          },
        })
      },
    )
    .addCase(
      storeActions.task.restore.fulfilled,
      (state, { payload: { task, notify } }) => {
        if (!notify) return
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xRestored',
          descriptionTransOptions: { value: task.title || task.content },
          icon: 'check',
          id: generateId(),
          undo: {
            actionType: 'restore',
            isUndone: false,
            object: task,
            type: 'task',
          },
        })
      },
    )
    .addCase(
      storeActions.task.update.fulfilled,
      (state, { payload: { task } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: task.title || task.content },
          icon: 'check',
          id: generateId(),
        })
      },
    )
}
